import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";

import Select from 'react-select';

class TagsMLComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {

          
            data: null,
            filtered: [],
            selectedAsset: null


        };

    }
    componentDidMount() {
        // This method is called when the component is first added to the document

        this.ensureDataFetched();

    }

    componentDidUpdate() {
        // This method is called when the route parameters change
        this.ensureDataFetched();
    }

    ensureDataFetched() {
     //   const shortlistID = this.props.match.params.shortlistID;
        // this.props.requestWeatherForecasts(startDateIndex);
   //     this.props.getShortList(shortlistID);
        this.props.getMLTags();
       

    }

    reorder(list, startIndex, endIndex) {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    moveSingleTrack(e) {
        var asset = this.props.tempShortList.filter(t => t.code == e.dataTransfer.getData("text"));
        if (asset != null) {
            this.props.AddSingeAssetToShortList(asset[0]);
        }
    }

    selectTrack(e) {

        var track = this.props.tagsML.filter(a => a.isrc === e);
        this.props.setMLAssetSelected(track[0]);
        console.log(track)
    }

    setData() {

        let arr = [];
        arr = this.props.selectedinstruments.concat(this.props.selectedaudio_tags).concat(this.props.selectedaudio_quality).concat(this.props.selectedMoods).concat(this.props.selectedEnvironmental);
        if (arr !== []) {
            this.props.SetTagToISRC(arr, this.props.selectedTagModel.isrc);
        }

    }
       

    renderData() {
        let asset = this.props.selectedMLAsset;

        if (asset != null) {
            return <div>               
               
                {this.renderTagsTable(asset.tags, this.props, this)}       
            </div>
        }

    }

    renderScreen() {
        return (

            <div >
                <table style={{ width: '100%' }}>
                    <tr>
                        <td style={{ width: '50%' }}>
                            {this.renderReactTable(this.props.tagsML, this.props, this)}
                        </td>
                        <td>
                            {this.renderData()}
                        </td>
                    </tr>
                </table>
                    {/*this.props.tempShortList != null && this.props.tempShortList.length > 0 ? this.renderSortableList() : ''*/}
               
               </div>      )
    }

    onFilteredChangeCustom = (value, accessor) => {
        let filtered = this.state.filtered;//this.props.filtered;
        let insertNewFilter = 1;



        if (filtered.length) {
            filtered.forEach((filter, i) => {
                if (filter["id"] === accessor) {
                    if (value === "" || value === null) filtered.splice(i, 1);
                    else filter["value"] = value;
                    insertNewFilter = 0;
                }
            });
        }

        if (insertNewFilter) {
            filtered.push({ id: accessor, value: value });
        }




        //this.props.setCatalogueFilter(filtered);
        this.setState({ filtered: filtered });
    };
   

    renderTagsTable(data, props, main) {
      
        const onRowClick = (state, rowInfo, column, instance) => {
            if (typeof rowInfo !== "undefined") {
                return {

                    style: {
                        background: rowInfo.original.show ? '' : '#fc9972',
                        color: 'black',
                    }
                }
            } else {
                return {
                    onClick: (e, handleOriginal) => {
                        if (handleOriginal) {
                            handleOriginal()
                        }
                    }
                }
            }
        }
        return (
            <ReactTable
                getTrProps={onRowClick}
                data={data}
                showPagination={false }
               

                defaultFilterMethod={(filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    if (typeof filter.value === "object") {
                        return row[id] !== undefined || row[id] !== null
                            ? filter.value.indexOf(row[id]) > -1
                            : true;
                    } else {
                        return row[id] !== undefined
                            ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                            : true;
                    }
                }}


                columns={[
                    {
                        Header: "Tags Detected",
                        columns: [
                            {
                                Header: "Name",
                                accessor: "name",                               
                            },
                            {
                                Header: "Model",
                                accessor: "model",
                                Cell: row => (
                                    <span style={{ cursor: 'pointer' }}> {row.value.includes("MSD") ? "MSD" : "MTT"}</span>
                                )
                            },
                            {
                                Header: "Confidence",
                                accessor: "confidence"
                            },
                            {
                                Header: "Visible",
                                accessor: "show",
                                Cell: row => (
                                    <span style={{ cursor: 'pointer' }}> {row.value? "Visible": "Hidden"}</span>
                                )
                            },
                            


                        ]
                    }
                ]}
                defaultSorted={[
                    {
                        id: "confidence",
                        desc: true
                    }
                ]}
                defaultPageSize={20}
                style={{
                    height: "700px" // This will force the table body to overflow and scroll, since there is not enough room
                }}
                className="-striped -highlight"
            />)
    };


     renderReactTable(data, props, main) {

    
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {

                style: {
                    background: props.selectedMLAsset && rowInfo.original.isrc === props.selectedMLAsset.isrc ? '#00afec' : rowInfo.original.verified === "Verified" ? '#99deab' : 'white' ,
                    color: 'black',
                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}

            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;
                if (typeof filter.value === "object") {
                    return row[id] !== undefined || row[id] !== null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}


            columns={[
                {
                    Header: "Basic Data",
                    columns: [
                        {
                            Header: "ISRC",
                            accessor: "isrc",
                            Cell: row => (
                                <span style={{ cursor: 'pointer' }} onClick={() => { main.selectTrack(row.value); props.setAudioUrl(row.original.fugaId); }}> {row.value}</span>
                            )
                        },                        
                        {
                            Header: "Title",
                            accessor: "name"
                        },
                        {
                            Header: "Version",
                            accessor: "version"
                        },
                        {
                            Header: "Artist",
                            accessor: "display_artist"
                        },
                        {
                            Header: "Genre",
                            accessor: "genre"
                        },
                        {
                            Header: "Sub Genre",
                            accessor: "subgenre"
                        },


                    ]
                }
            ]}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={50}
            style={{
                height: "700px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"            
        />)
};

    
    render() {
        
        return <div>

            <h2>Tag My Track Validation {this.props.selectedMLAsset ? " (" + this.props.selectedMLAsset.name + " | " + this.props.selectedMLAsset.display_artist + ")" : ""}</h2>
            <h3>{this.props.selectedMLAsset ? "key= " + this.props.selectedMLAsset.key + " bpm= " + this.props.selectedMLAsset.beat : ""}   </h3>
            {this.renderScreen()}          


        </div>
        
    }
}








export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(TagsMLComponent);



// WEBPACK FOOTER //
// ./src/components/TagsML.js